import React, { Component } from "react";
import { connect } from "react-redux";
import * as actions from "../actions/searchActions";
import {
  Button,
  Label,
  Media,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Row,
  Col
} from "reactstrap";
import { Calendar } from "react-widgets";
import Globalize from "globalize";
import globalizeLocalizer from "react-widgets-globalize";
import { dateToString } from "../helpers/utils";

import calendarImg from "../images/calendar.png";
import radioSelected from "../images/radioSelected.png";
import radioNotSelected from "../images/radioNotSelected.png";

import classes from "./DatesSort.module.scss";
import "react-widgets/dist/css/react-widgets.css";
import { globalizationData } from "../cldr-data/globalizationData";

class DatesSort extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: this.props.date,
      allDates: this.props.allDates,
      dateModalIsOpen: false
    };

    this.dateModalToggle = this.dateModalToggle.bind(this);

    Globalize.load(globalizationData);
    Globalize.loadTimeZone(require("iana-tz-data"));
    Globalize.locale("he"); //"he-u-nu-traditional"

    globalizeLocalizer();
  }

  onDateModalClose(handler) {
    this.dateModalToggle();
    handler();
  }

  dateModalToggle() {
    this.setState({
      dateModalIsOpen: !this.state.dateModalIsOpen
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.allDates || !nextProps.allDates) {
      this.setState({ allDates: nextProps.allDates });
    }
    if (nextProps.date) {
      this.setState({ date: nextProps.date });
    }
  }

  render() {
    return (
      <div>
        <Button
          color="light"
          onClick={this.dateModalToggle}
          className={classes.sortButton}
        >
          <span className={classes.dateLabelSpan}>
            {this.state.allDates
              ? "כל התאריכים"
              : dateToString(this.state.date)}
          </span>
          <Media
            src={calendarImg}
            alt="בחר תאריך"
            className={classes.sortImg}
          />
        </Button>
        <Modal
          isOpen={this.state.dateModalIsOpen}
          toggle={this.dateModalToggle}
          className={classes.dateModal}
          fade={false}
        >
          <ModalHeader className={classes.datesModalHeader}>
            <Button
              name="selectedDate"
              className={classes.dateOptionButton}
              color="link"
              onClick={() => this.props.allDatesChangeHandler(false)}
            >
              <Media
                src={this.state.allDates ? radioNotSelected : radioSelected}
                alt="תאריך ספציפי"
              />
            </Button>
            <Label className={classes.dateOptionLabel} for="selectedDate">
              תאריך ספציפי
            </Label>
            <Button
              name="allDates"
              className={classes.dateOptionButton}
              color="link"
              onClick={() => this.props.allDatesChangeHandler(true)}
            >
              <Media
                src={this.state.allDates ? radioSelected : radioNotSelected}
                alt="כל התאריכים"
              />
            </Button>
            <Label className={classes.dateOptionLabel} for="allDates">
              כל התאריכים
            </Label>
            {/* <Label className={classes.radioLabel} check>
                  <Input
                    type="radio"
                    name="dateOptions"
                    onChange={e => this.props.allDatesChangeHandler(false)}
                  />
                  תאריך ספציפי
                </Label>
                <Label className={classes.radioLabel} check>
                  <Input
                    type="radio"
                    name="dateOptions"
                    onChange={e => this.props.allDatesChangeHandler(true)}
                  />{" "}
                  כל התאריכים
                </Label> */}
          </ModalHeader>
          <ModalBody>
            {/* <Input
              type="checkbox"
              value={this.state.allDates}
              onChange={e => this.props.allDatesChangeHandler(e.target.checked)}
            />
            <Label> כל התאריכים</Label> */}

            <Row>
              <Col>
                <Calendar
                  disabled={this.state.allDates}
                  max={new Date()}
                  isRtl={true}
                  footer={false}
                  header={false}
                  defaultView="decade"
                  value={this.state.date}
                  onChange={value => this.props.dateChangeHandler(value)}
                />
              </Col>
            </Row>
          </ModalBody>
          <ModalFooter>
            <Button
              color="primary"
              onClick={e =>
                this.onDateModalClose(this.props.clearAndSearchHandler)
              }
            >
              סנן
            </Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    searchTerm: state.searchData.searchTerm,
    date: state.searchData.date,
    allDates: state.searchData.allDates
  };
};

const mapDispatchToProps = dispatch => {
  return {
    clearAndSearchHandler: () => dispatch(actions.clearDataAndSearch()),
    dateChangeHandler: value => dispatch(actions.setDate(value)),
    allDatesChangeHandler: value => dispatch(actions.setAllDates(value))
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DatesSort);
